import * as React from 'react';
import OrdersLayout from "../components/OrdersLayout"

const NewOrders: React.SFC = () => {
    return ( 
        <OrdersLayout/>
     );
}
 
export default NewOrders;